module.exports = __webpack_public_path__ + "img/btn_TOEIC_strategy_off.4aaaeb5a.png";